import { formatCurrency } from '@/utils/formatCurrency';

export function SuggestedBidDisplay({
  suggested,
  min,
  max,
}: {
  suggested: number | null;
  min?: number | null;
  max?: number | null;
}) {
  if (suggested == null) return <span className="text-foreground-muted">—</span>;
  const money = (value: number) =>
    formatCurrency(value, undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return (
    <span className="block text-right text-xs leading-4">
      <span className="block text-foreground">{money(suggested)}</span>
      {min != null && max != null ? (
        <span className="block text-foreground-muted">
          {money(min)} - {money(max)}
        </span>
      ) : null}
    </span>
  );
}
